"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The MediaFile model module.
 * @module model/MediaFile
 * @version 1.1.3-alpha.1
 */
class MediaFile {
  /**
   * Constructs a new <code>MediaFile</code>.
   * @alias module:model/MediaFile
   * @param id {Number} 
   * @param media_id {String} 
   * @param file_number {Number} 
   * @param file_index_id {String} 
   */
  constructor(id, media_id, file_number, file_index_id) {
    MediaFile.initialize(this, id, media_id, file_number, file_index_id);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, id, media_id, file_number, file_index_id) {
    obj['id'] = id;
    obj['media_id'] = media_id;
    obj['file_number'] = file_number;
    obj['file_index_id'] = file_index_id;
  }

  /**
   * Constructs a <code>MediaFile</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MediaFile} obj Optional instance to populate.
   * @return {module:model/MediaFile} The populated <code>MediaFile</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new MediaFile();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
      }
      if (data.hasOwnProperty('media_id')) {
        obj['media_id'] = _ApiClient.default.convertToType(data['media_id'], 'String');
      }
      if (data.hasOwnProperty('file_number')) {
        obj['file_number'] = _ApiClient.default.convertToType(data['file_number'], 'Number');
      }
      if (data.hasOwnProperty('file_index_id')) {
        obj['file_index_id'] = _ApiClient.default.convertToType(data['file_index_id'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>MediaFile</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MediaFile</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of MediaFile.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['media_id'] && !(typeof data['media_id'] === 'string' || data['media_id'] instanceof String)) {
      throw new Error("Expected the field `media_id` to be a primitive type in the JSON string but got " + data['media_id']);
    }
    // ensure the json data is a string
    if (data['file_index_id'] && !(typeof data['file_index_id'] === 'string' || data['file_index_id'] instanceof String)) {
      throw new Error("Expected the field `file_index_id` to be a primitive type in the JSON string but got " + data['file_index_id']);
    }
    return true;
  }
}
MediaFile.RequiredProperties = ["id", "media_id", "file_number", "file_index_id"];

/**
 * @member {Number} id
 */
MediaFile.prototype['id'] = undefined;

/**
 * @member {String} media_id
 */
MediaFile.prototype['media_id'] = undefined;

/**
 * @member {Number} file_number
 */
MediaFile.prototype['file_number'] = undefined;

/**
 * @member {String} file_index_id
 */
MediaFile.prototype['file_index_id'] = undefined;
var _default = MediaFile;
exports.default = _default;